import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enUS from "@/locales/en-US.json";
import zhCN from "@/locales/zh-CN.json";

export const SUPPORTED_LANGUAGES = ["zh-CN", "en-US"] as const;
export type AppLanguage = (typeof SUPPORTED_LANGUAGES)[number];

const STORAGE_KEY = "i18nextLng";

function readStoredLanguage(): AppLanguage {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === "zh-CN" || raw === "en-US") {
      return raw;
    }
  } catch {
    // ignore
  }
  return "zh-CN";
}

void i18n.use(initReactI18next).init({
  resources: {
    "zh-CN": { translation: zhCN },
    "en-US": { translation: enUS },
  },
  lng: readStoredLanguage(),
  fallbackLng: "zh-CN",
  interpolation: {
    escapeValue: false,
  },
});

i18n.on("languageChanged", (lng) => {
  try {
    if (lng === "zh-CN" || lng === "en-US") {
      localStorage.setItem(STORAGE_KEY, lng);
    }
  } catch {
    // ignore
  }
});

export async function changeLanguage(lng: AppLanguage): Promise<void> {
  await i18n.changeLanguage(lng);
}

export default i18n;
